import {API_BASE_URL} from '../constant/constant';



const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Something went wrong');
  }
  return response.json();
};


// Get purchase history API call
export const getPurchaseHistory = async (token) => {
  const response = await fetch(`${API_BASE_URL}/users/purchase-history`, {
    method: 'GET',
    headers:{
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });

  return handleResponse(response);
};


// Download receipt API call
export const downloadReceipt = async (purchaseId,token) => {
  const response = await fetch(`${API_BASE_URL}/users/purchase-history/${purchaseId}/receipt`, {
    method: 'GET',
    headers:{
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to download receipt');
  }

  return response.blob();
};



// Default export with all functions
const purchaseService = {
  getPurchaseHistory,
  downloadReceipt,
};

export default purchaseService;
